import { ApiService } from './../core/api-service/api.service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  private baseURL: string = environment.baseUrl;
  private gettokenUrl: string = this.baseURL + 'oauth/token';
  private insertBrowserLoggingUrl: string = this.baseURL + "api/questionare/browserLogging";
  private checkIfsessionExistsUrl: string = this.baseURL + "api/questionare/sessionExists/";
  private logoutUrl: string = this.baseURL + "api/questionare/logout/"
  public imageURL = new Subject<any>();
  public getCustomerUserInformationUrl: string = this.baseURL + "api/customers/getCustomerUserInformation";

  constructor(private http: HttpClient, private apiService: ApiService) { }


  userAuthentication(username, password): Observable<any> {
    var data = `grant_type=password&username=${username}&password=${encodeURIComponent(password)}`;
    var basicAuth = btoa("crmClient1:crmSuperSecret");
    var headerData = {
      "Content-Type": "application/x-www-form-urlencoded",
      "Authorization": "Basic " + basicAuth,
      "No-Auth": "True",
      'Access-Control-Allow-Origin': '*'
    };
    var reqHeader = new HttpHeaders(headerData);
    return this.apiService.post(this.gettokenUrl, data, reqHeader);

  }

  insertBrowserloggingInformation(email: String, browserInfo: String) {
    let data = {

      "customerBrowserInformation": browserInfo,
      "email": email
      // "sessionLastUpdatedTime": "2018-12-24T12:33:39.046Z"

    }
    return this.http.post(this.insertBrowserLoggingUrl, data);
  }

  checkIfSessionExists() {
    return this.http.get(this.checkIfsessionExistsUrl + sessionStorage.getItem("currentUserEmail"));
  }

  logoutInfo() {
    return this.http.get(this.logoutUrl + sessionStorage.getItem("currentUserEmail"));
  }

  logoutSisenseUser(options) {
    return this.http.get<any>('https://bi-ssl.fleet-assist.com:8081/api/v1/authentication/logout', options);
  }

  setProfilePicture(url: string) {
    this.imageURL.next(url)
  }

  getCustomerUserInformation() {
    return this.http.get(this.getCustomerUserInformationUrl);
  }

  updateCustomerUserInformation(data): Observable<any> {
    return this.http.post(`${this.baseURL}api/customers/updateCustomerUserInformationForManage`, data);
  }

  uploadAgreementAttachments(agreementFile: any): Observable<any> {
    return this.http.post(`${environment.baseUrl}uploadAgreementAttachments`, agreementFile);
  }

  getCustomerDetailsForMange(): Observable<any> {
    return this.http.get(`${environment.baseUrl}api/customers/getCustomerDetailsForManageCustomer`);
  }
}
